import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { URLQueryKeys } from '~/domains/common/types/URLQueryKeys';

import {
  clearWithdrawalAmountHandoff,
  parseWithdrawalAmountQuery,
  peekWithdrawalAmount,
} from '../utils/withdrawalAmountHandoff';

function useWithdrawalAmountHandoff(): number | undefined {
  const router = useRouter();
  const [preservedAmount] = useState(
    () =>
      peekWithdrawalAmount() ??
      parseWithdrawalAmountQuery(router.query[URLQueryKeys.WITHDRAWAL_AMOUNT])
  );

  useEffect(() => {
    clearWithdrawalAmountHandoff();
  }, []);

  useEffect(() => {
    if (router.query[URLQueryKeys.WITHDRAWAL_AMOUNT] === undefined) {
      return;
    }
    const query = { ...router.query };
    delete query[URLQueryKeys.WITHDRAWAL_AMOUNT];
    router.replace({ pathname: router.pathname, query }, undefined, { shallow: true });
  }, [router]);

  return preservedAmount;
}

export default useWithdrawalAmountHandoff;
